import { ClbInput } from "@celebration/react/ClbInput/ClbInput";
import type { InputEvent as ClbInputEvent } from "@celebration/react/ClbInput/ClbInput.types";
import type { InputProps } from "@components/contracts/Input.types";
import type React from "react";

const createChangeHandler =
  (onChange?: InputProps["onChange"]) => (event: ClbInputEvent) => {
    if (event.originalEvent.type === "clear") {
      onChange?.({
        ...event.originalEvent,
        target: { value: event.value } as HTMLInputElement,
        currentTarget: { value: event.value } as HTMLInputElement,
      } as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    onChange?.(event.originalEvent);
  };

export const CelebrationTextInput: React.FC<InputProps> = ({
  onChange,
  ...props
}) => (
  <ClbInput
    inputType="text"
    autoComplete="off"
    onChange={createChangeHandler(onChange)}
    {...props}
  />
);

export const CelebrationNumberInput: React.FC<InputProps> = ({
  onChange,
  ...props
}) => (
  <ClbInput
    inputType="number"
    autoComplete="off"
    onChange={createChangeHandler(onChange)}
    {...props}
  />
);
